const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
// @actions
const creditSituationAction = require('actions/credits/creditSituation');
const { requestAccountInterveners } = require('actions/getAccountInterveners');
// @constants
const CreditGeneralData = require('components/credits/creditGeneralData/creditGeneralData');
const { LOANS_MORTGAGES_INVESTMENT_CREDIT } = require('constants/index');

class CreditInvestmentView extends React.Component {
    constructor(props) {
        super(props);

        this.getCreditInformation = this.getCreditInformation.bind(this);
    }

    componentDidMount() {
        this.getCreditInformation();
        this.getCreditSituation();
    }

    getCreditInformation() {
        const { match: { params: { creditId } }, requestAccountInterveners } = this.props;
        requestAccountInterveners(creditId);
    }

    getCreditSituation() {
        const { match: { params: { creditId } }, requestCreditSituation } = this.props;

        requestCreditSituation(creditId);
    }

    render() {
        const { match: { params: { creditId } }, immInvestmentCredits, immAccounts, location } = this.props;
        let content = <LoadingSection />;

        if (!immInvestmentCredits.get('byOrder').isEmpty()) {
            const immCredit = immInvestmentCredits.getIn(['byId', creditId]);
            const immInterveners = immAccounts.getIn(['byId', creditId, 'interveners']);

            if (immCredit) {
                const showCreditSituation = (immCredit.get('type') === LOANS_MORTGAGES_INVESTMENT_CREDIT);

                content = (
                    <article className="investment-credit-view">
                        <CreditGeneralData immCredit={immCredit}
                            immInterveners={immInterveners}
                            getInformation={this.getCreditInformation}
                            path={location.pathname}
                            showCreditSituation={showCreditSituation}
                        />
                    </article>
                );
            }
        }

        return content;
    }
}

CreditInvestmentView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immInvestmentCredits: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    requestCreditSituation: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

module.exports.CreditInvestmentView = connect(
    state => ({
        immAccounts: state.accounts,
        immInvestmentCredits: state.creditsInvestment
    }),
    {
        requestAccountInterveners,
        requestCreditSituation: creditSituationAction.requestCreditSituation
    }
)(withRouter(CreditInvestmentView));
